import React from "react";
import { Dialog } from "primereact/dialog";

const AIEduDialog = ({
    visible,
    onHide,
    title,
    content,
    draggable,
    style,
    breakpoints,
    footer,
}) => {
    return (
        <>
            <Dialog
                visible={visible}
                onHide={onHide}
                header={title}
                style={style}
                draggable={draggable}
                breakpoints={breakpoints}
                footer={footer}
            >
                {content}
            </Dialog>
        </>
    );
};

export default AIEduDialog;
